import type { SaleProgressDefinition } from './saleProgress'

const files = import.meta.glob<SaleProgressDefinition>('./progress/*.ts', { eager: true, import: 'default' })

const saleTypeOf = (path: string) => path.replace(/^.*\//, '').replace(/\.ts$/, '')

export const PROGRESS_DEFINITIONS: Record<string, SaleProgressDefinition> = Object.fromEntries(
  Object.entries(files).map(([path, definition]) => [saleTypeOf(path), definition]),
)

export const progressDefinitionOf = (saleType: string): SaleProgressDefinition | undefined =>
  PROGRESS_DEFINITIONS[saleType]
